import store from '@/state/store';
import projectSlice from '@/state/project.slice';
import { participants as fetch } from '@/api/project';
import { handleError } from '@/actions/common';

export default async function (code: string): Promise<void> {
  try {
    const participants = await fetch(code);
    store.dispatch(projectSlice.actions.setParticipants({ code, participants }));
  } catch (error) {
    handleError(error);
    throw error;
  }
};